export const customColumnFormatOptions = [
  'text',
  'number',
  'currency',
  'percentage',
];

export const customColumnTypeOptions = ['single_input', 'select'];
